module.exports = __webpack_public_path__ + "img/wzlogo.f8fae9cf.png";